import {
  fadeLeft,
  fadeRight,
  staggerContainer,
} from '@/core/constants/animations'
import { cn } from '@/core/lib/utils/cn'
import { Motion } from '@/core/ui/atoms/motion'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { SliderModel } from '@/features/content/types/models/slider.model'

type Props = {
  className?: string
  slides: SliderModel[]
}

export const KidsSafety: React.FC<Props> = async ({
  className = '',
  slides,
}) => {
  const slide = slides[0]

  if (!slide || Object.keys(slide).length === 0) {
    return null
  }

  return (
    <Motion
      type='section'
      className={cn('flex flex-col items-center gap-16 md:flex-row', className)}
      variants={staggerContainer}
      initial='initial'
      whileInView='animate'
      viewport={{ once: true, amount: 0.3 }}
    >
      <Motion
        className='flex-1'
        variants={fadeLeft.variants}
        transition={fadeLeft.transition}
        initial='initial'
        whileInView='animate'
        viewport={{ once: true }}
      >
        <RemoteImage
          alt=''
          width={600}
          height={600}
          src={slide.image?.url}
          className='block h-full w-full max-w-lg'
        />
      </Motion>

      <Motion
        className='flex flex-1 flex-col gap-2'
        variants={fadeRight.variants}
        transition={fadeRight.transition}
      >
        <h2 className='text-sky-blue text-3xl font-bold lg:text-5xl'>
          {slide.title}
        </h2>
        <span
          className='[&_li]:before:border-sky-blue [&_li]:before:fill-sky-blue [&_li]:before:content-li-check [&_li]:flex [&_li]:items-start [&_li]:gap-2 [&_li]:before:mt-1 [&_li]:before:flex [&_li]:before:h-4 [&_li]:before:w-4 [&_li]:before:items-center [&_li]:before:justify-center [&_li]:before:rounded-full [&_li]:before:border [&_li]:before:bg-contain [&_li]:before:bg-no-repeat [&_li]:before:p-2 [&_ul]:list-none'
          dangerouslySetInnerHTML={{ __html: slide.description }}
        />
      </Motion>
    </Motion>
  )
}
